export const filterByDaysIntervalValues = ['7 dias', '15 dias', '30 dias', '60 dias', '90 dias'] as const;
export type FilterByDaysIntervalType = typeof filterByDaysIntervalValues[number];
